export default __webpack_public_path__ + "static/media/turkey.f96162b1.png";